import { render, staticRenderFns } from "./addRecedeMoney.vue?vue&type=template&id=4560a913&scoped=true&"
import script from "./addRecedeMoney.vue?vue&type=script&lang=js&"
export * from "./addRecedeMoney.vue?vue&type=script&lang=js&"
import style0 from "./addRecedeMoney.vue?vue&type=style&index=0&id=4560a913&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4560a913",
  null
  
)

export default component.exports